module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "movie-card"
  }, [_c('h5', [_vm._t("card-name")], 2), _vm._v(" "), _c('div', {
    staticClass: "movie-card--image"
  }), _vm._v(" "), _c('p', {
    staticClass: "movie-card--description"
  }, [_vm._v("\n                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n                    "), _c('sk-button', {
    attrs: {
      "link": "",
      "small": ""
    }
  }, [_vm._v("Read more")])], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6e7e4d6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/static-page/featured-movie-card/featured-movie-card.vue
// module id = 915
// module chunks = 0